import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { Shield } from 'lucide-react';

export function GuaranteeSection() {
    return (
        <section className="bg-navy-900 py-24 md:py-32" data-testid="guarantee-section">
            <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <div className="w-14 h-14 rounded-sm bg-white/10 flex items-center justify-center mx-auto mb-8">
                        <Shield size={28} className="text-gold-400" strokeWidth={1.5} />
                    </div>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white mb-6 tracking-tight">
                        If You Hit a Wall, We Don't Disappear.
                    </h2>
                    <p className="text-gray-300 text-lg leading-relaxed max-w-2xl mx-auto">
                        Most services place someone and walk away. We stay in it. Implementation challenges, VA performance, systems confusion - we step in and work through it with you. Hands-on. That's not a bonus. That's the baseline.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
